import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { H2 } from 'UIComponents/elements/headings';
import { DisplayMode } from 'automation-ui-formula-editor/fetch-object-panel/types/fetchObjectPanelTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogButton } from 'foundations-components/transitional/components/DialogButton';
import { LeftIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FetchObjectHeader = ({
  onBack,
  onClose,
  panelDisplayMode
}) => {
  let title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-formula-editor.fetch-object-panel.header.title.add-data-source"
  });
  if (panelDisplayMode === DisplayMode.SELECT) {
    title = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.fetch-object-panel.header.title.edit-data-source"
    });
  } else if (panelDisplayMode === DisplayMode.EDIT) {
    title = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.fetch-object-panel.header.title.update-data-source"
    });
  }
  return /*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [onBack && /*#__PURE__*/_jsx(DialogButton, {
      onClick: onBack,
      "aria-label": "back",
      icon: LeftIcon,
      marginInlineEnd: "400 !important"
    }), /*#__PURE__*/_jsx(H2, {
      children: title
    }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose
    })]
  });
};
export default FetchObjectHeader;